var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8158 6.31579H8.68421V1.18421C8.68421 0.536842 8.14737 0 7.5 0C6.85263 0 6.31579 0.536842 6.31579 1.18421V6.31579H1.18421C0.536842 6.31579 0 6.85263 0 7.5C0 8.14737 0.536842 8.68421 1.18421 8.68421H6.31579V13.8158C6.31579 14.4632 6.85263 15 7.5 15C8.14737 15 8.68421 14.4632 8.68421 13.8158V8.68421H13.8158C14.4632 8.68421 15 8.14737 15 7.5C15 6.85263 14.4632 6.31579 13.8158 6.31579Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d52ad80a4373dbe6e8a8780340875b4a.svg";
export { ForwardRef as ReactComponent };